import React, { Component } from 'react';
import CommToolContext from '../common/comm_tool_context';
import Review from './Review';
import { getProject, updateProject } from '../../api';
import Button from '../../components/Button';
import { Col, Row } from 'react-flexbox-grid';
import Alert from '../../components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import Spinner, { spinnerOff, spinnerOn } from '../../components/Spinner';
import { withRouter } from 'react-router-dom';
import ShowChecklistProjectConfirmDialog from './ChecklistProjectNAConfirmDialog';
import { isCreatorOrAdministrator } from '../../utils/UserInfo';
import UndoPopUp from '../../components/UndoPopUp';

class ReviewPage extends Component {
  constructor(props) {
    super(props);
    this.handleEditProject = this.handleEditProject.bind(this);
    this.releaseProject = this.releaseProject.bind(this);
    this.saveAndRedirect = this.saveAndRedirect.bind(this);
    this.noAssetConfirmation = this.noAssetConfirmation.bind(this);
    this.handleViewAsset = this.handleViewAsset.bind(this);
    this.checklistNAProject = this.checklistNAProject.bind(this);
    this.setState({ refresh: true });
  }

  state = {
    project: this.props.project,
    refresh: false
  };

  handleEditProject() {
    const { setActiveProject } = this.props.context;
    setActiveProject(this.props.project);
    this.props.history.push(`/development/${this.props.project.id}/details`);
  }

  handleReviewPageBack = () => {
    const { setActiveProject } = this.props.context;
    setActiveProject(this.props.project);
    this.props.history.push(`/development/${this.props.project.id}/team`);
  };

  handleViewAsset() {
    const { setActiveProject } = this.props.context;
    setActiveProject(this.props.project);
    this.props.history.push(
      `/development/${this.props.project.id}/assetsummary`
    );
  }

  async componentDidMount() {
    const recentProject = this.props.project;
    const project = await getProject(recentProject.id);
    this.setState({ project });
  }

  hideButtonGroup() {
    if (document.getElementById('dashboardBtn')) {
      document.getElementById('dashboardBtn').classList.add('disabledbutton');
    }
    document
      .getElementById('project-overview-release-button')
      .classList.add('disabledbutton');
    document
      .getElementById('project-overview-checklistna-button')
      .classList.add('disabledbutton');
    document.getElementById('undo-project').classList.add('disabledbutton');
  }

  unhideButtonGroup() {
    if (document.getElementById('dashboardBtn')) {
      document.getElementById('dashboardBtn').classList.add('disabledbutton');
    }
    document
      .getElementById('project-overview-release-button')
      .classList.remove('disabledbutton');
    document
      .getElementById('project-overview-checklistna-button')
      .classList.remove('disabledbutton');
    document.getElementById('undo-project').classList.remove('disabledbutton');
  }

  async saveAndRedirect(projStatus) {
    const { setActiveProject, setActiveDashboardTab, setRefreshNotifications } = this.props.context;
    const newAttributes = {
      workOrder: this.state.workOrder || this.props.project.workOrder,
      commissionStartDate:
        this.state.commissionStartDate || this.props.project.commisionStartDate,
      projectStatus: projStatus,
      showRemovalTasks:
        this.state.showRemovalTasks || this.props.project.showRemovalTasks,
      showSecurityTasks:
        this.state.showSecurityTasks || this.props.project.showSecurityTasks,
    };

    const updatedProject = {
      ...this.state.project,
      ...newAttributes,
    };
    spinnerOn();
    this.hideButtonGroup();
    await updateProject(updatedProject);
    setActiveProject(updatedProject);
    setRefreshNotifications(true);
    spinnerOff();
    this.unhideButtonGroup();
    setActiveDashboardTab(projStatus);
  }

  async releaseProject() {
    let verifyProject = await getProject(this.props.project.id);
    if (verifyProject.projectStatus !== 'D') {
      this.InvalidDataConfirm();
      this.props.history.push(`/dashboard/release`);
      return;
    }
    if (this.props.project.noOfAssets > 0) {
      
      if(
        !(
          this.props.project.showStationTeams == 1 ||
          this.props.project.showStationTeams == 0
        )||
        !(
          this.props.project.showStationContractors == 1 ||
          this.props.project.showStationContractors == 0
        )||
        !(
          this.props.project.showStationOfflineForms == 1 ||
          this.props.project.showStationOfflineForms == 0
        )||
        !(
          this.props.project.showPCTeams == 1 ||
          this.props.project.showPCTeams == 0
        )||
        !(
          this.props.project.showPCOfflineForms == 1 ||
          this.props.project.showPCOfflineForms == 0
        )||
        !(
          this.props.project.showNewStations == 1 ||
          this.props.project.showNewStations == 0
        )||
        !(
          (this.props.project.showHazardousMaterials == 1) ||
          this.props.project.showHazardousMaterials == 0
        )||
        !(
          this.props.project.showAssetHealth == 1 ||
          this.props.project.showAssetHealth == 0
        )||
        !(
          this.props.project.showDistributionAutomation == 1 ||
          this.props.project.showDistributionAutomation == 0
        )||
        !(
          this.props.project.showDropInControlModule == 1 ||
          this.props.project.showDropInControlModule == 0
        ) ||
        !(
          this.props.project.showRemovalTasks == 1 ||
          this.props.project.showRemovalTasks == 0
        ) ||
        !(
          this.props.project.showSecurityTasks == 1 ||
          this.props.project.showSecurityTasks == 0
        ) ||
        !(
          this.props.project.pcContractorSelected == 1 ||
          this.props.project.pcContractorSelected == 0
        )
      ) {
          let msg =
            'All the Questions must be answered ';
          confirmAlert({
            customUI: ({ onClose }) => {
              return <Alert msg={msg} onClose={onClose} />;
            },
          });
      }
      else {
        this.saveAndRedirect('R');
      }
    } else {
      this.noAssetConfirmation();
    }
  }

  /**
   *
   * Set project to Checklist NA and go back to the Active Tab
   */

  async checklistNAProject() {
    this.setState({ error: null });
    this.checkListNAProjectConfirm();
  }

  checkListNAProjectConfirm = () => {
    ShowChecklistProjectConfirmDialog(this.props.project, this.props.history, this.props.context);
  };

  noAssetConfirmation = () => {
    let msg = 'Unable to release a project with no assets';
    confirmAlert({
      customUI: ({ onClose }) => {
        return <Alert msg={msg} onClose={onClose} />;
      },
    });
  };

  noProjectTasks = (removalCheck, cipCheck) => {
    let msg =
      'Please select ' +
      (removalCheck === true ? 'Removals' : '') +
      (cipCheck === true ? 'CIP Security' : '');
    if (msg.includes('Removals') && msg.includes('CIP Security')) {
      msg = msg.replace('Removals', 'Removals, ');
    }
    msg = msg + ' options.';
    confirmAlert({
      customUI: ({ onClose }) => {
        return <Alert msg={msg} onClose={onClose} />;
      },
    });
  };

  InvalidDataConfirm = () => {
    let msg = 'This project was released by other user, Reloading..';
    confirmAlert({
      customUI: ({ onClose }) => {
        return <Alert msg={msg} onClose={onClose} />;
      },
    });
  };

  render() {
    const project = this.props.project;
    return (
      <div className='container-fluid'>
        <div className='row'>
          <Review
            project={this.props.project}
            onEditProject={this.handleEditProject}
            onEditTeam={this.handleReviewPageBack}
            onViewTeam={this.handleReviewPageBack}
            onViewAsset={this.handleViewAsset}
            teamMembers={this.props.teamMembers}
          />
        </div>
        <div className='container-fluid'>
          <Spinner />
          <Row className='projdtls-button' style={{ marginLeft: '-1.4rem' }}>
            <Col xs={12}>
              {isCreatorOrAdministrator() && (
                <Button
                  id='project-overview-release-button'
                  onClickHandler={this.releaseProject.bind(this, project)}
                >
                  Release
                </Button>
              )}
              {isCreatorOrAdministrator() && (
                <Button
                  id='project-overview-checklistna-button'
                  onClickHandler={this.checklistNAProject.bind(this)}
                >
                  Checklist N/A
                </Button>
              )}
              {isCreatorOrAdministrator() && (
                <UndoPopUp
                  project={project}
                  history={this.props.history}
                  context={this.props.context}
                  undoStatus={'Undo Start Project'}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

ReviewPage.contextType = CommToolContext;
export default withRouter(ReviewPage);
